import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GdoVehicleRoutingModule } from './gdo-vehicle-routing.module';
import { GdoVehicleContainerComponent } from './gdo-vehicle-container/gdo-vehicle-container.component';
import { GdoVehicleDetailComponent } from './gdo-vehicle-detail/gdo-vehicle-detail.component';
import { GdoSubscriptionDetailComponent } from './gdo-vehicle-detail/gdo-subscription-detail/gdo-subscription-detail.component';
import { GdoEditSubscriberContactInformationComponent } from './gdo-vehicle-detail/gdo-edit-subscriber-contact-information/gdo-edit-subscriber-contact-information.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { GdoManageSubscriptionComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-manage-subscription.component';
import { GdoSelectSubscriptionComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-select-subscription/gdo-select-subscription.component';
import { GdoSubscriptionItemComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-select-subscription/gdo-subscription-item/gdo-subscription-item.component';
import { GdoSubscriptionContactInformationComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-subscription-contact-information/gdo-subscription-contact-information.component';
import { GdoSubscriptionCreatePinComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-subscription-create-pin/gdo-subscription-create-pin.component';
import { GdoSubscriptionPaymentMethodComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-subscription-payment-method/gdo-subscription-payment-method.component';
import { GdoSubscriptionSummaryComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-subscription-summary/gdo-subscription-summary.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from 'src/app/shared/shared.module';
import { GdoPaymentModule } from '../gdo-payment/gdo-payment.module';

@NgModule({
  declarations: [
    GdoVehicleContainerComponent,
    GdoVehicleDetailComponent,
    GdoSubscriptionDetailComponent,
    GdoEditSubscriberContactInformationComponent,
    GdoManageSubscriptionComponent,
    GdoSubscriptionSummaryComponent,
    GdoSubscriptionPaymentMethodComponent,
    GdoSubscriptionCreatePinComponent,
    GdoSubscriptionContactInformationComponent,
    GdoSelectSubscriptionComponent,
    GdoSubscriptionItemComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatGridListModule,
    MatRadioModule,
    MatStepperModule,
    SharedModule,
    MatTabsModule,
    MatListModule,
    GdoVehicleRoutingModule,
    GdoPaymentModule
  ],
  exports:[
    GdoSubscriptionSummaryComponent,
    GdoSubscriptionPaymentMethodComponent,
    GdoSubscriptionCreatePinComponent,
    GdoSubscriptionContactInformationComponent,
    GdoSelectSubscriptionComponent,
    GdoSubscriptionItemComponent

  ]
})
export class GdoVehicleModule { }
